import React, { useContext, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import Select from "components/common/Select";
import FormAdvancedOptions from "./FormAdvancedOptions";
import INITIAL_FORMDATA from "./_initialFormData";
import FormWrap from "../common/FormWrap";
const StepSubscribe = ({ onSubmit, onChange }) => {
  var _a, _b, _c;
  const { t } = useTranslation("enterprise_integrations");
  const { formData, setFormData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { pollingInterval } = formData;
  const availableContent = [
    { label: t("microsoftgraph.content_types.email_logs"), value: "EMAIL_LOGS" },
    { label: t("microsoftgraph.content_types.directory_audit_logs"), value: "DIRECTORY_AUDIT_LOGS" },
    { label: t("microsoftgraph.content_types.sign_in_audit_logs"), value: "SIGN_IN_AUDIT_LOGS" },
    { label: t("microsoftgraph.content_types.provisioning_audit_logs"), value: "PROVISIONING_AUDIT_LOGS" },
    { label: t("microsoftgraph.content_types.security_alerts_v2_logs"), value: "SECURITY_ALERTS_V2_LOGS" },
    { label: t("microsoftgraph.content_types.security_incidents_logs"), value: "SECURITY_INCIDENTS_LOGS" }
  ];
  const subscriptionType = (_a = formData.subscriptionType) == null ? void 0 : _a.value;
  const defaultContentTypes = useMemo(() => {
    if (subscriptionType !== "GLOBAL") {
      return INITIAL_FORMDATA.availableContents.value.split(",").filter((x) => x !== "SIGN_IN_AUDIT_LOGS").join(",");
    }
    return INITIAL_FORMDATA.availableContents.value;
  }, [subscriptionType]);
  const contentTypes = ((_b = formData.content_type) == null ? void 0 : _b.value) || defaultContentTypes;
  useEffect(() => {
    var _a2;
    if (!((_a2 = formData.content_type) == null ? void 0 : _a2.value)) {
      setFormData("content_type", { value: defaultContentTypes });
    }
  }, [defaultContentTypes, (_c = formData.content_type) == null ? void 0 : _c.value, setFormData]);
  const handleSubmit = () => {
    let error = false;
    if (pollingInterval.value < 1) {
      setFormError({
        full_message: t("common.validation.polling_interval_invalid"),
        nice_message: t("common.validation.polling_interval_min")
      });
      error = true;
    }
    if (!error) {
      setFormError(null);
      setFormData("content_type", { value: contentTypes });
      onSubmit();
    }
  };
  const handleReadTimeOffsetChange = (errorMessage) => {
    if (errorMessage) {
      setFormError({
        full_message: errorMessage,
        nice_message: errorMessage
      });
    } else {
      setFormError(null);
    }
  };
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: t("common.buttons.proceed"),
      title: "",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement("label", { className: "control-label", htmlFor: "contents" }, t("microsoftgraph.subscribe.log_types_label")),
    /* @__PURE__ */ React.createElement(
      Select,
      {
        multi: true,
        name: "content_type",
        id: "content_type",
        onChange: (selected) => setFormData("content_type", { value: selected }),
        options: availableContent,
        value: contentTypes
      }
    ),
    /* @__PURE__ */ React.createElement("span", { className: "help-block" }, t("microsoftgraph.subscribe.content_types_help")),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "pollingInterval",
        name: "pollingInterval",
        type: "number",
        value: pollingInterval.value || pollingInterval.defaultValue || "",
        min: "1",
        max: "60",
        step: "1",
        onChange,
        required: true,
        help: t("microsoftgraph.subscribe.polling_interval_help"),
        label: t("common.fields.polling_interval")
      }
    ),
    /* @__PURE__ */ React.createElement(FormAdvancedOptions, { onChange, handleReadTimeOffsetChange })
  );
};
export default StepSubscribe;
